import { Component, OnInit, Input } from '@angular/core';
import { ColumnsService } from 'app/private/sxfdesigner/services/columns-service';
import { ColumnsAttribute } from 'app/private/sxfdesigner/types/designer-attribute-type';

@Component({
    selector: 'app-columns-modal-advanced',
    templateUrl: 'columns-modal-advanced.component.html'
})
export class SxColumnsModalAdvancedComponent implements OnInit {

    readonly DEFAULT_COLOR = '#ffffff';

    cols: number;
    spacing: Spacing;

    @Input()
    item: ColumnsAttribute;
    columns: any[];
    unusedModules: any[];
    active: any;
    usedModules = 0;
    maxModules = 12;

    constructor(private columnsService: ColumnsService) {
        this.columnsService.generalColumns$.subscribe(g => {
            this.cols = g.length;
            const columns = new Array(this.cols);
            for (let index = 0; index < g.length; index++) {
                const element = g[index];
                columns[index] = {...element, sizes: new Array(element.width)};
            }
            this.modifyColumns( (index) => {
                return {
                        active: ColumnUsage.Inactive,
                        width: columns[index].width,
                        color: this.checkIfColorIsEmpty(columns[index].color),
                        sizes: columns[index].sizes
                    };
            } );
        });
    }

    ngOnInit(): void {
        this.spacing = this.item.spacing;
    }

    checkIfColorIsEmpty(color:string){
        return color ? color : this.DEFAULT_COLOR
    }

    changedColumns() {
        this.modifyColumns((index) => {
            return {
                active: ColumnUsage.Inactive,
                width: 1,
                color: this.DEFAULT_COLOR,
                sizes: [1]
            };
        });
        this.columnsService.modifyAdvancedColumns(this.columns);
    }

    modifyColumns( columnCreator ) {
        this.columns = new Array(this.cols);
        const active = 0;
        let index = 0;
        this.usedModules = 0;
        for (index; index < this.cols; index++) {
            const element = columnCreator(index);
            this.columns[index] = element;
            this.usedModules += element.width;
        }
        this.calculateUnusedModules();
        this.changeActive(this.columns[0]);
        this.columnsService.modifyAdvancedColumns(this.columns);
    }

    changeActive(column: any) {
        if (this.active) {
            this.active.active = ColumnUsage.Inactive;
        }
        this.active = column;
        column.active = ColumnUsage.Active;
        this.columnsService.modifyAdvancedColumns(this.columns);
    }

    widthChange(newWidth: any) {
        if (newWidth - this.active.width > this.unusedModules.length) {
            return;
        }
        this.usedModules = this.usedModules - this.active.width + newWidth;
        this.active.width = newWidth;
        this.active.sizes = new Array(this.active.width);
        this.calculateUnusedModules();
        this.columnsService.modifyAdvancedColumns(this.columns);
    }

    colorChanged(newColor: any) {
        this.active.color = newColor;
        this.columnsService.modifyAdvancedColumns(this.columns);
    }

    spacingChanged(newSpace: Spacing) {
        this.spacing = newSpace;
        this.columnsService.modifySpacing(this.spacing);
    }

    calculateUnusedModules = () => this.unusedModules = new Array(this.maxModules - this.usedModules);

}

export enum Spacing {
    NoSpace = 'noSpace',
    Default = 'Default'
}

enum ColumnUsage {
    Active,
    Inactive,
    Unused
}



// WEBPACK FOOTER //
// D:/a/1/s/BackOffice/SOC/SxSoc.ClientWeb/src/app/private/sxfdesigner/components/modals/tabs/advanced/columns-modal-advanced.component.ts